import tabs from "./modules/tabs";
import form from "./modules/form";
import cards from "./modules/cards";
import calculator from "./modules/calculator";
import modal from "./modules/modal";
import slider from "./modules/slider";
import timer from "./modules/timer";


window.addEventListener("DOMContentLoaded", () => {
    tabs();
    cards();
    calculator();
    form();
    modal();
    slider();
    timer();
})